<template>
<div>


<v-card flat v-if="!this.$store.state.H5P.isVideoReady && this.$store.state.currentEditTab == 'bookmark_tab'">



    <v-progress-linear
      indeterminate
      color="green"
    ></v-progress-linear>

    <v-card-text> Initializing Shuttle... </v-card-text>

</v-card>


<v-card flat text v-if="this.$store.state.H5P.isVideoReady && this.$store.state.currentEditTab == 'bookmark_tab'">

  <v-toolbar flat>
          <v-toolbar-title>Current Bookmarks</v-toolbar-title>


          <v-spacer></v-spacer>

      <!-- @click="newBookmark()" -->
      <v-btn width="100" outlined small color="primary" @click="displayForm()">
       + Add
      </v-btn>

      </v-toolbar>


      <v-card class="mr-3 ml-3" v-if="display_form">
        <v-card-subtitle class="font-weight-bold">ADD NEW BOOKMARK</v-card-subtitle>
        <v-card-text>
          <v-text-field
            v-model="currentBookmark.time"
            label="Bookmark Video at (seconds)"
            outlined

          ></v-text-field>
          <v-text-field
            v-model="currentBookmark.label"
            label="Bookmark Label"
            outlined

          ></v-text-field>



        </v-card-text>

        <div class="text-right">
          <v-btn width="100" small outlined text color="primary" class="mx-4 mb-4" @click="closeFormDisplay()">
            Cancel
          </v-btn>
          <v-btn width="100" small color="primary" class="mx-4 mb-4" @click="saveBookmark()" :loading="imaging">
            Save
          </v-btn>
        </div>

      </v-card>
<v-row>

  <v-col cols="12" md="12" sm="12">



                          <v-data-iterator
                            class="pa-3"
                            :items="bookmarksList"
                            items-per-page.sync="10"

                            no-data-text="Click the '+ ADD' button above to add your first bookmark. Bookmarks provide learners with quicklinks to specific topics or section within your video. Add timestamp and label to create a bookmark."
                          >

                        <template v-slot:header>
                        </template>

                        <template v-slot:default="props">

                        <v-container>

                            <v-row>
                                <v-col
                                  v-for="(item, bookmark_idx) in props.items"
                                  :key="bookmark_idx"
                                  cols="12"
                                  sm="12"
                                  md="12"
                                  class="pt-0"
                                >
                                  <v-card v-show="editing_item !== bookmark_idx">

                                    <v-row>
                                      <v-col cols="2" class="ma-0">

                                        <v-img height="80" width="80" contain :src="item.image"

                                        :lazy-src="item.image"
                                         aspect-ratio="1"
                                        ><template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-row>
                              </template></v-img>



                                      </v-col>

                                      <v-col cols="8" class="text-left">
                                        <div class="subheading font-weight-bold">{{ item.label }}</div>
                                        <div>{{ fmtMSS(item.time) }}</div>

                                      </v-col>

                                      <v-col cols="2">
                                        <v-btn icon   @click="editItem(item, bookmark_idx)">
                                          <v-icon


                                          >
                                            mdi-pencil
                                          </v-icon>
                                        </v-btn>


                                        <v-btn icon @click="deleteItem(item)">
                                          <v-icon



                                          >
                                            mdi-delete-forever-outline
                                          </v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>

                                  </v-card>



                                  <v-card v-show="bookmark_idx === editing_item">
                                    <v-card-subtitle class="font-weight-bold">EDIT BOOKMARK</v-card-subtitle>
                                    <v-card-text>
                                      <v-text-field
                                        v-model="currentBookmark.time"
                                        label="Bookmark Video at (hh:mm:ss)"
                                        outlined
                                          placeholder="hh:mm:ss"
                                          :error="bookmark_time_error"
                                           @blur="validateForm('bookmarkTime')"

                                      ></v-text-field>
                                      <v-text-field
                                        v-model="currentBookmark.label"
                                        label="Bookmark Label"
                                        outlined

                                      ></v-text-field>



                                    </v-card-text>

                                    <div class="text-right">
                                      <v-btn width="100" small outlined text color="primary" class="mx-4 mb-4" @click="closeEditFormDisplay()">
                                        Cancel
                                      </v-btn>
                                      <v-btn width="100" small color="primary" class="mx-4 mb-4" @click="saveBookmark()" :loading="imaging">
                                        Save
                                      </v-btn>
                                    </div>

                                  </v-card>


                                </v-col>
                            </v-row>
                          </v-container>
                        </template>






                          </v-data-iterator>

  </v-col>

  <v-col cols="12" sm="6">


<v-row>
  <v-col cols="12" sm="12">
<canvas id="canvas_bookmark" style="height:1px;width:1px;"></canvas>
<!-- <v-img max-height="320" max-width="320"   :src="currentBookmark.image" contain id="poster_image"></v-img> -->
   </v-col>

</v-row>


<v-row>

  <v-col cols="12" sm="3">



    <!--                        <v-progress-circular
      v-if="imaging"
      :size="64"
      :width="7"
      color="blue"
      indeterminate
    ></v-progress-circular>
  -->
   </v-col>

</v-row>


  </v-col>


</v-row>




</v-card>




</div>

</template>

<script>

	import { mapGetters } from 'vuex'
  import ShuttleMixins from '@/mixins/ShuttleMixins.js';
   import validations from '@/mixins/validations.js'; 
export default {
  name: 'ShuttleBookmarks',
  mixins:[ShuttleMixins,validations],
    data() {
    	return {
          editing_item: -1,
    			imaging:false,
          bookmarkTime:'0:00',
          bookmark_src:'',
          bookmarkLabel:'',
          bookmark_time_error:false,




          display_form: false,
         bookmarksList:[],
             headers: [

          { text: 'Image', value: 'image' },
          { text: 'Time', value: 'time' },
          { text: 'Label', value: 'label' },
          { text: 'Actions', value: 'actions', sortable: false }
        ],


    	}
	},

	computed: {



	},
props:{

	tabupdate:Number
},
watch:{

	tabupdate(){

		//if (this.tabupdate === 1) { this.init(); }
    this.init();
	},








},



 created(){

      var vm = this;
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
            ////console.log(mutation.type);
            if (mutation.type  === 'currentShuttle' ||mutation.type === 'currentShuttleBookmarks'){
                vm.init();

            }


               if (mutation.type  === 'updateShuttles'
                && this.$store.state.currentEditTab == 'bookmark_tab'){

                ////console.log('transcript mutation: ' + mutation.type )
                vm.init();
              }



              if( mutation.type === 'H5P' && this.$store.state.currentEditTab == 'bookmark_tab'){
                // //console.log('transcript mutation: ' + mutation.type )

                  this.setBookmarkListener();
                //H5P.externalDispatcher.on('domChanged', vm.H5PDomReady);
              }


          });

 },
  beforeDestroy() {
    this.unsubscribe();
  },


	mounted(){
			//this.init()
	},

	 methods: {

      validateForm(source){

          var val;

          switch(source){
              case 'bookmarkTime':
                  
                  val = this.validateFormattedTime(this.currentBookmark.time,this.$store.state.currentShuttle.duration);

                  if(!val.success){

                    this.$store.commit('global_message', {message: val.message,color:'error'});
                    this.bookmark_time_error = true
                  } else {

                    this.bookmark_time_error = false;


                  }


                  
              break;

          }


      },
	 		init(){

	 			this.$store.commit('help', 'video_bookmarks');

        this.bookmarksList = this.$store.state.currentShuttle.bookmarks !== undefined ? this.$store.state.currentShuttle.bookmarks : [];


	 		},



      fmtMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+Math.round(s)},


      displayForm() {
        this.display_form = true;
        this.newBookmark();
      },

      closeFormDisplay() {
        this.display_form = false;
        this.newBookmark();
      },

      closeEditFormDisplay() {
        this.editing_item = -1;
        this.newBookmark();
      },



      newBookmark(){

          this.editing_item = -1;

          var t =this.fmtMSS(this.getVideoCurrentTime());


          this.currentBookmark = {
              time:t,
              label:'',
              image:''

          };




      },

      editItem(item, selected_idx) {
          this.display_form = false;
          this.editing_item = selected_idx;
          this.seekCurrentVideo(item.time);
          this.currentBookmark = {
              time:this.fmtMSS(item.time),
              label:item.label,
              image:item.image

          };



      },


      deleteItem(item){
          this.bookmarksList = this.bookmarksList.filter(bookmark => bookmark.time != item.time);
          this.$store.commit('currentShuttleBookmarks', this.bookmarksList);
          this.generateDynamicH5p();
          this.saveShuttle();

          this.currentBookmark = {
              time:'0:00',
              label:'',
              image:''

          };

      },

      async saveBookmark(){



        if(!this.bookmark_time_error){

            this.imaging = true;
            await this.createBookmarkImage();


            //first look to see if we are editing an existing bookmark

             var existingBookmark = this.bookmarksList.filter(bookmark => bookmark.time == this.hmsToSecondsOnly(this.currentBookmark.time));
             var bookmark_index = this.bookmarksList.findIndex(obj => obj.time == this.hmsToSecondsOnly(this.currentBookmark.time));


            if(bookmark_index > -1){



                  this.bookmarksList[bookmark_index].label = this.currentBookmark.label;
                  this.bookmarksList[bookmark_index].time = this.hmsToSecondsOnly(this.currentBookmark.time);
                  this.bookmarksList[bookmark_index].image = this.currentBookmark.image;



            } else {

                
                  var newBookmark = {};
                  newBookmark.label = this.currentBookmark.label;
                  newBookmark.time = this.hmsToSecondsOnly(this.currentBookmark.time);
                  newBookmark.image = this.currentBookmark.image;

                  this.bookmarksList.push(newBookmark);


            }

            //reorder by timestamp
            this.bookmarksList = this.bookmarksList.sort((a, b) => (a.time > b.time) ? 1 : -1)


             this.$store.commit('currentShuttleBookmarks', this.bookmarksList);
             this.saveShuttle();
             this.imaging = false;
             this.display_form = false;
             this.editing_item = -1;
             this.generateDynamicH5p();
           } else {
              this.$store.commit('global_message', {message: 'Error with a form value',color:'error'});


           }

      },

    setBookmarkListener(){
        //console.log('Bookmark LISTENER')
        var vm = this;
        this.seekCurrentVideo(this.currentBookmark.time);
        this.H5PObject.video.on('videoTimeUpdate',function(e){vm.setBookmarkTime(e.data)});




    },



	 		async createBookmarkImage(){

	 				this.imaging = true;
					var image_data = this.getCurrentFrameImage('canvas_bookmark');
					if(image_data.success){


                  this.bookmark_src= image_data.data;
                  //his.currentBookmark.image = image_data.data; // need to turn into url when submitting / updaitng

          

          var ts = new Date().getTime();

             let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/shuttle/canvas-image';
              let postdata = {
                customer_id:this.$store.state.auth.sub,
                shuttle_id:this.$store.state.currentShuttle.id,
                filename:'bookmark_' + this.$store.state.currentShuttle.id + '_' + ts,
                base64:this.bookmark_src
              }

              let response = await this.getData( path,'post',postdata);

              if(response.success){
                this.currentBookmark.image = this.$store.state.uri.app_base_uri + '/' + response.filepath;
              }



				}
        this.imaging = false;

	 		},


	 		saveVideoOptions(){

	 			var vidObj = {title:this.video_title,description:this.video_description};
      			this.$store.commit('currentShuttleVideoOptions', vidObj);

            //console.log('------------------- SAVE SHUTTLE -------------------- ')
            //console.log('------------------- BOOKMARK -------------------- ')

      			this.saveShuttle();
	 		},


      async downloadShuttle(){

          var downlodpath = this.$store.state.uri.app_base_uri + '/uploads/' + this.$store.state.currentShuttle.customer_id + '/shuttles/' + this.$store.state.currentShuttle.id + '/package/shuttle.h5p';


          document.location.href = downlodpath;

      },


     async packageShuttle(){
            this.packing = true;
            this.$store.commit('packageready', false);
            let path  = this.$store.state.endpoint.post_customer + '/' +this.$store.state.auth.sub + '/shuttle/package';
            let postdata = this.$store.state.currentShuttle;
            let packageresponse = await this.getData( path,'post',postdata);
            this.packing = false;
            //console.log(packageresponse)
            if(packageresponse.success){
            this.$store.commit('packageready', true);

          }

      }


	 }//end methods

}

</script>
